import React, { useState, useEffect, useCallback } from "react";
import { Button, Table } from "react-bootstrap";
import { useAuthContext } from "../../../../context/AuthContext";
import { Link } from "react-router-dom";
import getSimilarCandidateV2 from "../../../../apis/getSimilarCandidateV2";
import ProfileImageMd from "../../../../components/CommonComponent/ProfileImageMd";
import FullCircleChart from "../FullCircleChart";
import CandidateScoreTabs from "./CandidateScoreTabs";

const SimilarCandidates = (props) => {
  const { resourceSlug, actualProfileName } = props;
  const { userDetails } = useAuthContext();
  const user_slug = JSON.parse(userDetails).user_slug;

  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [dataArray, setDataArray] = useState([]);
  const [jobScore, setJobScore] = useState(0);
  const [eduScore, setEduScore] = useState(0);
  const [skillScore, setSkillScore] = useState(0);
  const [industryScore, setIndustryScore] = useState(0);
  const [lngScore, setLngScore] = useState(0);
  const [mlScore, setMlScore] = useState(0);
  const [cScore, setCScore] = useState(0);
  const [exScore, setExScore] = useState(0);
  const [filterData, setFilterData] = useState(false);
  const [filterArray, setFilterArray] = useState([
    {
      name: "Skills",
      value: 0,
      type: "sk",
      remove: 0,
    },
    {
      name: "Certifications",
      value: 0,
      type: "crt",
      remove: 0,
    },
    {
      name: "Education",
      value: 0,
      type: "edu",
      remove: 0,
    },
    {
      name: "Management Experience",
      value: 0,
      type: "ml",
      remove: 0,
    },
    {
      name: "Industries",
      value: 0,
      type: "in",
      remove: 0,
    },

    {
      name: "Languages",
      value: 0,
      type: "lng",
      remove: 0,
    },
  ]);

  const [expandedRowKey, setExpandedRowKey] = useState(null);

  const handleRowToggle = (key) => {
    setExpandedRowKey((prev) => (prev === key ? null : key));
  };

  useEffect(() => {
    if (resourceSlug) {
      fetchSimilarCandidate();
    }
  }, [resourceSlug]);

  const updateEachFilterValue = useCallback(() => {
    filterArray.map((item) => {
      if (item.type === "jt") {
        return setJobScore(item.value);
      } else if (item.type === "crt") {
        return setCScore(item.value);
      } else if (item.type === "edu") {
        return setEduScore(item.value);
      } else if (item.type === "et") {
        return setExScore(item.value);
      } else if (item.type === "in") {
        return setIndustryScore(item.value);
      } else if (item.type === "lng") {
        return setLngScore(item.value);
      } else if (item.type === "ml") {
        return setMlScore(item.value);
      } else if (item.type === "sk") {
        return setSkillScore(item.value);
      } else {
        return true;
      }
    });
  }, [filterArray]);

  useEffect(() => {
    updateEachFilterValue();
  }, [filterArray, updateEachFilterValue]);

  const fetchSimilarCandidate = () => {
    setIsLoading(true);
    Promise.all([
      getSimilarCandidateV2(
        resourceSlug,
        user_slug,
        jobScore,
        eduScore,
        skillScore,
        industryScore,
        lngScore,
        mlScore,
        cScore,
        exScore
      ),
    ])
      .then(async ([data]) => {
        if (data?.data?.matches) {
          await setDataArray(data?.data?.matches);
          await setFilterData(data?.data?.filters_has_data);

          let newFilterArray = filterArray;

          await newFilterArray.map((item, index) => {
            if (item.type === "jt") {
              if (
                data?.data?.filters_has_data?.JobTitlesHasData ||
                data?.data?.filters_has_data?.JobTitles !== 0
              ) {
                return (
                  (newFilterArray[index].value = parseInt(
                    data?.data?.filters_has_data?.JobTitles * 100
                  )),
                  (newFilterArray[index].remove = 0)
                );
              } else {
                return (newFilterArray[index].remove = 1);
              }
            } else if (item.type === "crt") {
              if (
                data?.data?.filters_has_data?.CertificationsHasData ||
                data?.data?.filters_has_data?.Certifications !== 0
              ) {
                return (
                  (newFilterArray[index].value = parseInt(
                    data?.data?.filters_has_data?.Certifications * 100
                  )),
                  (newFilterArray[index].remove = 0)
                );
              } else {
                return (newFilterArray[index].remove = 1);
              }
            } else if (item.type === "edu") {
              if (
                data?.data?.filters_has_data?.EducationHasData ||
                data?.data?.filters_has_data?.Education !== 0
              ) {
                return (
                  (newFilterArray[index].value = parseInt(
                    data?.data?.filters_has_data?.Education * 100
                  )),
                  (newFilterArray[index].remove = 0)
                );
              } else {
                return (newFilterArray[index].remove = 1);
              }
            } else if (item.type === "et") {
              if (data?.data?.filters_has_data?.ExecutiveTypeHasData) {
                return (
                  (newFilterArray[index].value = parseInt(
                    data?.data?.filters_has_data?.ExecutiveType * 100
                  )),
                  (newFilterArray[index].remove = 0)
                );
              } else {
                return (newFilterArray[index].remove = 1);
              }
            } else if (item.type === "in") {
              if (
                data?.data?.filters_has_data?.IndustriesHasData ||
                data?.data?.filters_has_data?.Industries !== 0
              ) {
                return (
                  (newFilterArray[index].value = parseInt(
                    data?.data?.filters_has_data?.Industries * 100
                  )),
                  (newFilterArray[index].remove = 0)
                );
              } else {
                return (newFilterArray[index].remove = 1);
              }
            } else if (item.type === "lng") {
              if (
                data?.data?.filters_has_data?.LanguagesHasData ||
                data?.data?.filters_has_data?.Languages !== 0
              ) {
                return (
                  (newFilterArray[index].value = parseInt(
                    data?.data?.filters_has_data?.Languages * 100
                  )),
                  (newFilterArray[index].remove = 0)
                );
              } else {
                return (newFilterArray[index].remove = 1);
              }
            } else if (item.type === "ml") {
              if (
                data?.data?.filters_has_data?.ManagementLevelHasData ||
                data?.data?.filters_has_data?.ManagementLevel !== 0
              ) {
                return (
                  (newFilterArray[index].value = parseInt(
                    data?.data?.filters_has_data?.ManagementLevel * 100
                  )),
                  (newFilterArray[index].remove = 0)
                );
              } else {
                return (newFilterArray[index].remove = 1);
              }
            } else if (item.type === "sk") {
              if (
                data?.data?.filters_has_data?.SkillsHasData ||
                data?.data?.filters_has_data?.Skills !== 0
              ) {
                return (
                  (newFilterArray[index].value = parseInt(
                    data?.data?.filters_has_data?.Skills * 100
                  )),
                  (newFilterArray[index].remove = 0)
                );
              } else {
                return (newFilterArray[index].remove = 1);
              }
            } else {
              return true;
            }
          });

          setIsLoading(false);
        } else {
          setErrorMessage(data?.data?.message);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const updateValue = useCallback(
    async (val, type) => {
      var position = 0;
      var newFilter = [];

      await filterArray.map((item, index) => {
        if (item.type === type) {
          if (item.value < val.target.value) {
            position = true;
          } else {
            position = false;
          }
          return (newFilter[index] = { ...item, value: val.target.value });
        } else {
          return (newFilter[index] = item);
        }
      });

      await newFilter.map((item, index) => {
        if (item.type !== type) {
          if (position) {
            if (item.value > 0) {
              return (newFilter[index] = {
                ...item,
                value: item.value - 1,
              });
            } else {
              return false;
            }
          } else if (item.value < 100) {
            return (newFilter[index] = {
              ...item,
              value: item.value + 1,
            });
          } else {
            return false;
          }
        } else {
          return item;
        }
      });

      await setFilterArray(newFilter);
    },
    [filterArray]
  );

  const displayFilters = useCallback(() => {
    const preferredOrder = [
      { name: "Skills", type: "sk" },
      { name: "Certifications", type: "crt" },
      { name: "Education", type: "edu" },
      { name: "Management Experience", type: "ml" },
      { name: "Industries", type: "in" },
      { name: "Languages", type: "lng" },
    ];

    return (
      <div className="d-flex flex-nowrap overflow-auto gap-3 py-2">
        {preferredOrder.map(({ name, type }) => {
          const item = filterArray?.find(
            (f) => f?.name === name && f?.type === type && !f?.remove
          );

          if (!item) return null;

          return (
            <div
              key={type}
              className="d-flex flex-column"
              style={{ minWidth: "160px" }}
            >
              <div className="mb-1">
                <small>{item.name}</small>
              </div>
              <input
                type="range"
                className="form-range"
                min="0"
                max="100"
                step="1"
                value={item.value}
                onChange={(e) => updateValue(e, item.type)}
                style={{
                  "--range-progress": `${item.value}%`,
                }}
              />
            </div>
          );
        })}
      </div>
    );
  }, [filterArray, updateValue]);

  return (
    <div className="card">
      {isLoading ? (
        <div className="card-body">
          <div className="d-flex justify-content-center align-items-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <>
          {!!dataArray?.length ? (
            <div className="card-body">
              <h5>Adjust Importance</h5>
              <span className="text-secondary">
                Adjust the importance of each category here. This will affect
                how each match is scored.
              </span>
              <div className="justify-content-between align-items-center my-4">
                <div>
                  <Button
                    variant="primary"
                    size={"sm"}
                    onClick={() => fetchSimilarCandidate()}
                  >
                    Update
                  </Button>
                </div>
                {filterData ? <>{displayFilters()}</> : null}
              </div>
              <div className="table-wrapper">
                {/* Header Row */}
                <div
                  className="header-row bg-light text-muted fw-bold small px-3 py-2 border-bottom"
                  style={{
                    borderTopLeftRadius: "0.5rem",
                    borderTopRightRadius: "0.5rem",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div style={{ width: "4.5rem" }}>Score</div>
                  <div className="col-custom">Candidate</div>
                  <div className="col-custom">Role</div>
                  <div className="col-custom">Location</div>
                  <div style={{ width: "6.5rem" }}>Availability</div>
                  <div className="col-custom d-flex justify-content-end">
                    Action
                  </div>
                </div>

                {/* Data Rows */}
                {dataArray?.map((item, key) => {
                  if (!item?.profile) return null; // ✅ Skip if profile is missing

                  return (
                    <div
                      key={key.toString()}
                      className="border-bottom"
                      style={{
                        borderLeft:
                          expandedRowKey === key ? "4px solid #0d6efd" : "none",
                      }}
                    >
                      <div className="data-row d-flex align-items-center py-3">
                        {/* Score */}
                        <div style={{ width: "4.5rem" }}>
                          <span className="badge bg-light text-dark fs-6">
                            {item?.score}
                          </span>
                        </div>

                        {/* Candidate */}
                        <div className="col-custom">
                          <div className="d-flex align-items-center">
                            <ProfileImageMd
                              imgSrc={item?.profile?.profile_image_path}
                            />
                            <div className="ms-3">
                              <div>
                                <span className="fw-bold">
                                  {item?.profile?.r_name}
                                </span>
                              </div>
                              <div>
                                <Link to="#">
                                  <small
                                    className="text-primary"
                                    title={item?.profile?.user_email}
                                  >
                                    {item?.profile?.user_email?.length > 30
                                      ? item?.profile?.user_email.substr(
                                          0,
                                          30
                                        ) + "..."
                                      : item?.profile?.user_email}
                                  </small>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Role */}
                        <div className="col-custom text-wrap">
                          <small title={item?.profile?.user_profile_role}>
                            {item?.profile?.user_profile_role?.length > 50
                              ? item?.profile?.user_profile_role.substr(0, 50) +
                                "..."
                              : item?.profile?.user_profile_role}
                          </small>
                        </div>

                        {/* Location */}
                        <div className="col-custom text-wrap">
                          <small className="text-dark">
                            {item?.profile?.city_name
                              ? item?.profile?.city_name + ", "
                              : ""}
                            {item?.profile?.state_name
                              ? item?.profile?.state_name + ", "
                              : ""}
                            {item?.profile?.country_name}
                          </small>
                        </div>

                        {/* Availability */}
                        <div style={{ width: "6.5rem" }}>
                          <FullCircleChart
                            value={parseInt(item?.profile?.availability)}
                            size={40}
                          />
                        </div>

                        {/* Actions */}
                        <div className="col-custom d-flex justify-content-end gap-2">
                          <Link
                            to={`/resources/details/${item?.profile?.user_slug}`}
                            target="_blank"
                          >
                            <Button variant="outline-secondary" size="sm">
                              View Profile
                            </Button>
                          </Link>
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => handleRowToggle(key)}
                          >
                            View Scoring
                          </Button>
                        </div>
                      </div>

                      {expandedRowKey === key && (
                        <CandidateScoreTabs
                          item={item}
                          actualProfileName={actualProfileName}
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div role="alert" class="fade alert alert-info show">
              {errorMessage}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SimilarCandidates;
